// React and related imports
import React from 'react';

// Flowbite components
import { Table } from 'flowbite-react';

// Custom components
import { SortingIcon } from '../Shared/Icons/SortingIcon';

interface TableHeadProps {
  columns: { id: string; label: string; sortable?: boolean }[];
  onClick?: (fieldId: string) => void;
  withSortingIcon?: boolean;
}

export const TableHead: React.FC<TableHeadProps> = ({ columns, onClick }) => (
  <Table.Head>
    {columns.map((column, index) => (
      <Table.HeadCell
        key={index}
        className="icon-primary cursor-pointer border border-primary-500 bg-primary-500 text-center text-white dark:border-white dark:bg-primary-600"
      >
        <span className="flex items-center justify-center">
          {column.label}
          {columns.length - 1 != index && column.sortable && onClick && (
            <SortingIcon onClick={onClick} fieldId={column.id} />
          )}
        </span>
      </Table.HeadCell>
    ))}
  </Table.Head>
);

interface TableCommonProps {
  columns: { id: string; label: string }[];
  onClick?: (fieldId: string) => void;
  children: React.ReactNode;
}

export const TableCommon: React.FC<TableCommonProps> = ({
  columns,
  children,
  onClick,
}) => (
  <div className="mb-5 max-w-full overflow-x-auto">
    <Table>
      <TableHead columns={columns} onClick={onClick} />
      <Table.Body>{children}</Table.Body>
    </Table>
  </div>
);

export const TableCell: React.FC<{
  children: React.ReactNode;
  classes?: string;
}> = ({ children, classes }) => (
  <Table.Cell className={`border ${classes ? classes : 'text-center'}`}>
    {children}
  </Table.Cell>
);
